'use strict'

(global._ ? require 'underscore').mixin
  omitUndefined: (obj) ->
    filteredObj = {}
    for key, value of obj
      filteredObj[key] = value if value?
    filteredObj

  indexBy: (list, iterator) ->
    returnedHash = {}
    returnedHash[listItem[iterator]] = listItem for listItem in list or []
    returnedHash

  hasSubstring: (str, subString) ->
    typeof str is "string" and str.indexOf(subString) >= 0

  capitalize: (str) ->
    str.charAt(0).toUpperCase() + str.substring(1)

  deQuotify: (str) ->
    return unless str?
    str.replace(/&quot;/g, '"')

  getDecodedParam: (param) ->
    return null unless param
    try
      decodeURIComponent param
    catch
      null

